import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "row m-0" }
const _hoisted_3 = { class: "col-12 p-0" }
const _hoisted_4 = { class: "login-card" }
const _hoisted_5 = { class: "login-main" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-input position-relative" }
const _hoisted_8 = ["type"]
const _hoisted_9 = { class: "show-hide" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-input position-relative" }
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "show-hide" }
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_15 = { class: "form-group mb-0" }
const _hoisted_16 = { class: "text-end mt-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "mt-4 mb-0 text-center" }

import { ref, computed, onMounted, watch } from "vue";
import { createToaster } from "@meforma/vue-toaster";
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'resetPasswordPage',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const toaster = createToaster({});
const router = useRouter();
const route = useRoute();

const resetToken = ref<string>("");
const newPassword = ref<string>("");
const confirmPassword = ref<string>("");
const isSubmitting = ref<boolean>(false);
const passwordType = ref<string>('password');
const confirmPasswordType = ref<string>('password');

const passwordMismatch = computed<boolean>(() => {
    return !!(newPassword.value && confirmPassword.value) && 
           newPassword.value !== confirmPassword.value;
});

onMounted(() => {
    // Get token from query parameters
    if (route.query.token) {
        resetToken.value = route.query.token as string;
    } else {
        // Redirect to forgot password page if no token is provided
        router.push('/auth/forgot-password');
        toaster.show("Password reset token is missing or expired", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
    }
});

function togglePasswordVisibility(field: string) {
    if (field === 'password') {
        passwordType.value = passwordType.value === 'password' ? 'text' : 'password';
    } else {
        confirmPasswordType.value = confirmPasswordType.value === 'password' ? 'text' : 'password';
    }
}

async function resetPassword() {
    // Validate inputs
    if (!newPassword.value || !confirmPassword.value) {
        toaster.show("Please fill in all fields", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
        return;
    }

    if (passwordMismatch.value) {
        toaster.show("Passwords do not match", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
        return;
    }

    if (newPassword.value.length < 8) {
        toaster.show("Password must be at least 8 characters long", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
        return;
    }

    isSubmitting.value = true;
    try {
        const response = await axios.post(`${baseUrl}api/user/reset-password-with-otp`, {
            resetToken: resetToken.value,
            newPassword: newPassword.value,
            confirmPassword: confirmPassword.value
        });

        toaster.show("Password has been reset successfully", {
            theme: 'outline',
            position: 'top-right',
            icon: 'check',
            type: 'success',
            duration: 3000
        });

        // Redirect to login page after successful password reset
        setTimeout(() => {
            router.push('/auth/login');
        }, 1500);
    } catch (error: any) {
        console.error('Error resetting password:', error);
        toaster.show(error.response?.data?.message || "Failed to reset password. Please try again.", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
    } finally {
        isSubmitting.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("div", null, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("form", {
                class: "theme-form",
                onSubmit: _withModifiers(resetPassword, ["prevent"])
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "text-center" }, "Reset Password", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-center" }, "Create a new password for your account", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "col-form-label" }, "New Password", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
                      type: passwordType.value,
                      class: "form-control",
                      placeholder: "Enter new password",
                      required: "",
                      minlength: "8"
                    }, null, 8, _hoisted_8), [
                      [_vModelDynamic, newPassword.value]
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", {
                        class: "show",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (togglePasswordVisibility('password')))
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "col-form-label" }, "Confirm Password", -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmPassword).value = $event)),
                      type: confirmPasswordType.value,
                      class: "form-control",
                      placeholder: "Confirm new password",
                      required: "",
                      minlength: "8"
                    }, null, 8, _hoisted_12), [
                      [_vModelDynamic, confirmPassword.value]
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", {
                        class: "show",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (togglePasswordVisibility('confirm')))
                      })
                    ])
                  ])
                ]),
                (passwordMismatch.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Passwords do not match! "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      class: "btn btn-primary btn-block w-100",
                      type: "submit",
                      disabled: isSubmitting.value || passwordMismatch.value
                    }, _toDisplayString(isSubmitting.value ? 'Resetting Password...' : 'Reset Password'), 9, _hoisted_17)
                  ])
                ]),
                _createElementVNode("p", _hoisted_18, [
                  _createVNode(_component_router_link, {
                    class: "ms-2",
                    to: "/auth/login"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Back to Login ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})